<template>
  <v-btn
      :disabled="disabled"
      :class="schema['x-class']"
      v-bind="schema['x-props']"
      style="text-transform: none"
      @click="onClick"
      tile
  >
    <v-icon
        v-if="iconFlag"
        left
        :color="iconColor"
        :size="iconSize"
    >
      {{ icon }}
    </v-icon>
    <div>
      {{ text }}
    </div>
  </v-btn>
</template>

<script>

import exprEvalParser from "@koumoul/vjsf/lib/utils/expr-eval-parser";

export default {
  name: "TcnBtn",
  components: {},
  props: {
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
    modelRoot: {type: Object, required: true},
  },
  data() {
    return {
      exprResult: null,
    }
  },
  computed: {
    expDataFakeWrapper() {
      return this.modelRoot !== null ? {parent: {value: this.modelRoot}} : null
    },

    iconFlag() {
      return this.schema['iconMode'] || false
    },

    icon() {
      return this.schema['icon'] || "mdi-home"
    },

    iconColor() {
      return this.schema['iconColor'] || ""
    },

    iconSize(){
      return this.schema["iconSize"] || 22
    },

    text() {
      return this.schema['text'] || "Przycisk"
    },
    expr() {
      return this.schema['actionAttrs'] || null
    },
    workMode() {
      return this.schema["workMode"] || "action"
    }
  },
  watch: {
    modelRoot: {
      handler() {
        if (this.expr !== null && exprEvalParser.evaluate(this.expr, this.expDataFakeWrapper) !== undefined) {
          this.exprResult = exprEvalParser.evaluate(this.expr, this.expDataFakeWrapper)
        }
      },
      deep: true
    }
  },
  methods: {
    onClick() {
      console.log("nip w button", this.exprResult)
      if (this.workMode === 'action') {
        const obj = {}
        obj.code = this.schema['actionCode']
        obj.actionAttrs = this.exprResult
        this.$emit("resolveAction", obj)
      }
      if (this.workMode === "func") {
        this.options[this.fullKey].func()
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped lang="css">

</style>
